import { Heart, MessageSquare, Star, Target, Lightbulb, Search, Eye } from "lucide-react";

const FeaturesSection = () => {
  const features = [
    {
      icon: Heart,
      title: "100% Personalized",
      description: "Our Love Report is crafted from your exact birth details. It analyzes your zodiac, planets, and charts to reveal your unique love, nature, compatibility, and relationship patterns."
    },
    {
      icon: MessageSquare,
      title: "Plain And Easy Language",
      description: "Our Love Report makes astrology simple, offering clear guidance on love and relationships in easy-to-understand language."
    },
    {
      icon: Star,
      title: "Expert Guidance By Acharya Luvbhushan",
      description: "With years of expertise, Acharya LavBhushan provides accurate, insightful readings to guide your love life meaningfully."
    },
    {
      icon: Lightbulb,
      title: "Actionable Remedies & Advice",
      description: "Our Love Report gives clear guidance to overcome obstacles, improve relationships, and build a happier, more harmonious love life."
    },
    {
      icon: Search,
      title: "In-Depth Love Insights",
      description: "The Love Report covers your full love life—personality, compatibility, future predictions, and tailored guidance for your unique astrological chart—helping you handle relationships with clarity and confidence."
    },
    {
      icon: Target,
      title: "Clarity & Confidence in Your Love Life",
      description: "Whether single, committed, or facing challenges, our Love Report reveals your love future, highlights obstacles, and guides you toward your destined relationship."
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground_lv mb-4">
            Why Use Our Love Report?
          </h2>
          <p className="text-muted_lv-foreground max-w-4xl mx-auto text-base lg:text-lg">
            Our Love Report is not a generic horoscope—it's a highly in-depth, meaningful guide to your love life, designed under the expert supervision of
            Acharya LavBhushan. Here's why you need to use our Love Report:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-card_lv border border-love-pink/20 rounded-xl p-4 lg:p-6 text-center hover:shadow-lg transition-all duration-300 hover:shadow-love-pink/20 hover:border-love-pink/40"
            >
              <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-br from-love-pink to-love-secondary rounded-full flex items-center justify-center mx-auto mb-3 lg:mb-4">
                <feature.icon className="w-6 h-6 lg:w-8 lg:h-8 text-white" />
              </div>
              <h3 className="text-base lg:text-lg font-semibold text-foreground_lv mb-2 lg:mb-3">
                {feature.title}
              </h3>
              <p className="text-muted_lv-foreground text-xs lg:text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;